module.exports = __webpack_public_path__ + "img/Senegal.341d3e5f.gif";